import React from 'react';
import jwtFromLocalStorage from './jwtFromLocalStorage';
import userTypeFromLocalStorage from './userTypeFromLocalStorage';
import { IndexRedirect } from 'react-router';

export const redirectWhenRootPage = () =>  {
  if (jwtFromLocalStorage()) {
    return redirectDependsOnUserType();
  }
  return <IndexRedirect to='/login' />;
};

const redirectDependsOnUserType = () => {
  if (userTypeFromLocalStorage() === 'manager') {
    return <IndexRedirect to='/managers/calendar' />;
  } else if (userTypeFromLocalStorage() === 'rep') {
    return <IndexRedirect to='/reps/books' />;
  }
  return false;
};



// WEBPACK FOOTER //
// ./app/lib/redirect.js